import { Provider } from '@angular/core';
import { GallerySlideComponentType } from '../../models';
import { ARTICLE_INFO_TICKET_SLIDE_COMPONENT_SCHEMA, SPACER_SLIDE_COMPONENT_SCHEMA } from '../../schemas';
import { GALLERY_SLIDE_COMPONENTS_REGISTRY, GallerySlideComponentDefinition } from './gallery-slide.components.service';

/**
 * Default gallery-slide-component dictionary. Intentionally NOT re-exported through the
 * services barrel — apps import the provider by deep path. Same rationale as
 * `page.components.registry.ts`.
 */
export const GALLERY_SLIDE_COMPONENTS_DEFAULT: Record<GallerySlideComponentType, GallerySlideComponentDefinition> = {
  ArticleInfoTicket: {
    name: 'gallerySlideComponents.articleInfoTicket.name',
    group: 'basic',
    iconName: 'calendar-star',
    loadComponent: () =>
      import(
        '../../template/app/gallery-slide-components/gallery-slide-article-info-ticket/gallery-slide-article-info-ticket.component'
      ).then((m) => m.GallerySlideArticleInfoTicketComponent),
    formSchema: ARTICLE_INFO_TICKET_SLIDE_COMPONENT_SCHEMA,
    backendComponent: true,
    bcModules: ['*', 'webshop']
  },
  Spacer: {
    name: 'gallerySlideComponents.spacer.name',
    group: 'basic',
    iconName: 'arrows-vertical',
    loadComponent: () =>
      import('../../template/app/gallery-slide-components/gallery-slide-spacer/gallery-slide-spacer.component').then(
        (m) => m.GallerySlideSpacerComponent
      ),
    formSchema: SPACER_SLIDE_COMPONENT_SCHEMA,
    backendComponent: false,
    bcModules: ['*', 'website']
  }
};

/** Provider for the default gallery-slide-component registry. Register once in app.config. */
export const GALLERY_SLIDE_COMPONENTS_REGISTRY_PROVIDER: Provider = {
  provide: GALLERY_SLIDE_COMPONENTS_REGISTRY,
  useValue: GALLERY_SLIDE_COMPONENTS_DEFAULT
};
